import axios from "axios";
import { responseError } from "./UtilService";

const api_url_clientes = process.env.REACT_APP_API_URL + "/ranking/clientes"
const api_url_marcas = process.env.REACT_APP_API_URL + "/ranking/marcas"

export async function getRankingClientes(fechaDesde, fechaHasta) {
    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += "&fechaHasta="+fechaHasta;
    }
    params += "&estado=F";
    try {
        let resp = await axios.get(api_url_clientes+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err,"Hubo un error al obtener datos de ranking de clientes desde el servidor.");
    }
}

export async function getRankingMarcas(fechaDesde, fechaHasta) {
    let params = "";
    if (fechaDesde) {
        params += "?fechaDesde="+fechaDesde;
    }
    if (fechaHasta) {
        params += "&fechaHasta="+fechaHasta;
    }
    try {
        let resp = await axios.get(api_url_marcas+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener datos de ranking de marcas desde el servidor.");
    }
}